import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[OnlyDecimal]'
})
export class OnlyDecimalDirective {

private regex: RegExp = new RegExp(/^[0-9]*\.?[0-9]*$/);

// Allow key codes for special events
// Backspace, tab, end, home
private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'Delete', 'ArrowLeft', 'ArrowRight'];

constructor(private el: ElementRef) {
}

@HostListener('keydown', ['$event'])
onKeyDown(event: KeyboardEvent) {

    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
        return;
    }

    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);

    if (next && !String(next).match(this.regex)) {
        event.preventDefault();
    }
}
}
